<div class="container-fluid">
    <div class="row">
        <div class="col-md-12 col-lg-12 col-12">
            <!-- ========== PAGE WRAPPER (full height, screen-based) ========== -->
            <div class="att-page-wrap">
                <!-- ========== MINIMAL ACTIONS (no card) ========== -->
                <div class="att-actions-bar">
                    <span class="att-actions-title">Section Wise Attendance</span>
                    <div class="att-actions-buttons">
                        <button type="button" class="att-filter-dialog-btn" (click)="openAttendanceFilterDialog()"
                            title="Open filter dialog">
                            <i class="fa fa-filter"></i> Filter
                        </button>
                        <button type="button" class="att-campus-btn att-campus-show-btn"
                            (click)="openCampusSummaryDialog()" title="Campus Attendances">
                            <i class="fa fa-university"></i>Campus
                        </button>
                    </div>
                </div>

                <!-- ========== SECTION STATS ========== -->
                <div class="att-stats-wrapper" [class.att-stats-collapsed]="!isStatsExpanded">
                    <div *ngIf="activeTab === 'section' && hasStudents" class="col-md-12">
                        <div class="att-stats-grid">

                            <div class="att-stat-card att-stat-total" (click)="setFilter('ALL')"
                                [class.att-stat-active]="filterStatus === 'ALL'">
                                <div class="att-stat-icon"><i class="fa fa-users"></i></div>
                                <div class="att-stat-text">
                                    <div class="att-stat-label">Total Students</div>
                                    <div class="att-stat-value">{{ totalStudents }}</div>
                                </div>
                            </div>

                            <div class="att-stat-card att-stat-present" (click)="setFilter('P')"
                                [class.att-stat-active]="filterStatus === 'P'">
                                <div class="att-stat-icon"><i class="fa fa-check-circle"></i></div>
                                <div class="att-stat-text">
                                    <div class="att-stat-label">Present</div>
                                    <div class="att-stat-value">{{ presentCount }}</div>
                                </div>
                            </div>

                            <div class="att-stat-card att-stat-absent" (click)="setFilter('A')"
                                [class.att-stat-active]="filterStatus === 'A'">
                                <div class="att-stat-icon"><i class="fa fa-times-circle"></i></div>
                                <div class="att-stat-text">
                                    <div class="att-stat-label">Absent</div>
                                    <div class="att-stat-value">{{ absentCount }}</div>
                                </div>
                            </div>

                            <div class="att-stat-card att-stat-sick" (click)="setFilter('S')"
                                [class.att-stat-active]="filterStatus === 'S'">
                                <div class="att-stat-icon"><i class="fa fa-heartbeat"></i></div>
                                <div class="att-stat-text">
                                    <div class="att-stat-label">Sick</div>
                                    <div class="att-stat-value">{{ sickCount }}</div>
                                </div>
                            </div>

                            <div class="att-stat-card att-stat-outing" (click)="setFilter('O')"
                                [class.att-stat-active]="filterStatus === 'O'">
                                <div class="att-stat-icon"><i class="fa fa-external-link"></i></div>
                                <div class="att-stat-text">
                                    <div class="att-stat-label">Outing</div>
                                    <div class="att-stat-value">{{ outingCount }}</div>
                                </div>
                            </div>

                            <div class="att-stat-card att-stat-transfer" (click)="setFilter('TI')"
                                [class.att-stat-active]="filterStatus === 'TI'">
                                <div class="att-stat-icon"><i class="fa fa-exchange"></i></div>
                                <div class="att-stat-text">
                                    <div class="att-stat-label">Transfer In</div>
                                    <div class="att-stat-value">{{ transferInCount }}</div>
                                </div>
                            </div>

                            <div class="att-stat-card att-stat-transfer" (click)="setFilter('TO')"
                                [class.att-stat-active]="filterStatus === 'TO'">
                                <div class="att-stat-icon"><i class="fa fa-exchange"></i></div>
                                <div class="att-stat-text">
                                    <div class="att-stat-label">Transfer Out</div>
                                    <div class="att-stat-value">{{ transferOutCount }}</div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                <!-- ========== NO STUDENTS IN SECTION ========== -->
                <div *ngIf="activeTab === 'section' && studentsNotAllotted && !hasStudents"
                    class="att-no-students-panel">
                    <div class="att-no-students-card">
                        <i class="fa fa-exclamation-circle att-no-students-icon"></i>
                        <h5 class="att-no-students-title">This section students are not allotted</h5>
                        <p class="att-no-students-text">
                            No student records found for
                            <strong>{{ selectedStudyClassName || '—' }}</strong> ·
                            <strong>{{ selectedSectionName || '—' }}</strong>.
                            Please select another section or check allotment.
                        </p>
                        <button type="button" class="att-filter-dialog-btn att-no-students-btn"
                            (click)="openAttendanceFilterDialog()">
                            <i class="fa fa-filter"></i> Change Filter
                        </button>
                    </div>
                </div>

                <!-- ========== COMPACT TABLE MODEL ========== -->
                <div *ngIf="activeTab === 'section' && hasStudents" class="att-table-section">
                    <div class="att-table-panel">
                        <div class="att-section-header">
                            <div class="att-section-filters">
                                <span class="att-section-title">
                                    <i class="fa fa-calendar"></i> Date: <strong>{{ attendanceDate | date:'dd-MM-yyyy'
                                        }}</strong>
                                </span>
                                <span class="att-section-title">
                                    <i class="fa fa-graduation-cap"></i> Class: <strong>{{ selectedStudyClassName || '—'
                                        }}</strong>
                                </span>
                                <span class="att-section-title">
                                    <i class="fa fa-users"></i> Section: <strong>{{ selectedSectionName || '—'
                                        }}</strong>
                                </span>
                                <span class="att-section-count">
                                    Total Students: <strong>{{ totalStudents }}</strong>
                                </span>
                            </div>
                            <div class="att-section-search-wrap">
                                <i class="fa fa-search att-section-search-icon"></i>
                                <input type="text" class="att-section-search-input" placeholder="Search in table..."
                                    [(ngModel)]="tableSearchQuery" (ngModelChange)="onTableSearchChange()" />
                            </div>
                        </div>
                        <div class="att-table-scroll" [class.att-table-expanded]="!isStatsExpanded">
                            <table mat-table [dataSource]="getFilteredTableStudents()"
                                class="att-table mat-elevation-z0">

                                <!-- S.No -->
                                <ng-container matColumnDef="sno">
                                    <th mat-header-cell *matHeaderCellDef class="att-th att-th-sno">S.No</th>
                                    <td mat-cell *matCellDef="let e; let i = index" class="att-td">{{ i + 1 }}</td>
                                </ng-container>

                                <!-- Adm No -->
                                <ng-container matColumnDef="admNo">
                                    <th mat-header-cell *matHeaderCellDef class="att-th">Adm. No</th>
                                    <td mat-cell *matCellDef="let e" class="att-td att-td-admno">{{ e.admNo }}</td>
                                </ng-container>

                                <!-- Name -->
                                <ng-container matColumnDef="name">
                                    <th mat-header-cell *matHeaderCellDef class="att-th">Student Name</th>
                                    <td mat-cell *matCellDef="let e" class="att-td att-td-name">
                                        <span>{{ e.name }}</span>
                                        <span class="att-transfer-badge att-transfer-in" *ngIf="e.transferredIn">In</span>
                                        <span class="att-transfer-badge att-transfer-out" *ngIf="e.transferredOut">Out</span>
                                    </td>
                                </ng-container>

                                <!-- Course -->
                                <ng-container matColumnDef="course">
                                    <th mat-header-cell *matHeaderCellDef class="att-th">Course</th>
                                    <td mat-cell *matCellDef="let e" class="att-td">{{ e.course }}</td>
                                </ng-container>

                                <!-- Section -->
                                <ng-container matColumnDef="section">
                                    <th mat-header-cell *matHeaderCellDef class="att-th">Section</th>
                                    <td mat-cell *matCellDef="let e" class="att-td">{{ e.section }}</td>
                                </ng-container>

                                <!-- Status -->
                                <ng-container matColumnDef="status">
                                    <th mat-header-cell *matHeaderCellDef class="att-th">
                                        <div class="att-bulk-header">
                                            <span>Status</span>
                                            <div class="att-bulk-checks">
                                                <button type="button" class="att-bulk-label att-bulk-h"
                                                    [class.att-bulk-on]="selectedStatus === 'H'"
                                                    (click)="toggleBulkAttendance('H', $event)">
                                                    <span class="att-bulk-box" aria-hidden="true"></span>
                                                    H
                                                </button>
                                                <button type="button" class="att-bulk-label att-bulk-p"
                                                    [class.att-bulk-on]="selectedStatus === 'P'"
                                                    (click)="toggleBulkAttendance('P', $event)">
                                                    <span class="att-bulk-box" aria-hidden="true"></span>
                                                    P
                                                </button>
                                                <button type="button" class="att-bulk-label att-bulk-o"
                                                    [class.att-bulk-on]="selectedStatus === 'O'"
                                                    (click)="toggleBulkAttendance('O', $event)">
                                                    <span class="att-bulk-box" aria-hidden="true"></span>
                                                    O
                                                </button>
                                            </div>
                                        </div>
                                    </th>
                                    <td mat-cell *matCellDef="let e" class="att-td">
                                        <div class="att-radio-group"
                                            [class.att-radio-readonly]="isAttendanceReadonly(e)">
                                            <label class="att-radio-label att-radio-p"
                                                [class.att-radio-active]="e.attendance === 'P'"
                                                (click)="!isAttendanceReadonly(e) && onAttendanceChange(e, 'P')">
                                                <input type="radio" name="att{{e.admNo}}" value="P"
                                                    [ngModel]="e.attendance" [disabled]="isAttendanceReadonly(e)"> P
                                            </label>
                                            <label class="att-radio-label att-radio-a"
                                                [class.att-radio-active]="e.attendance === 'A'"
                                                (click)="!isAttendanceReadonly(e) && onAttendanceChange(e, 'A')">
                                                <input type="radio" name="att{{e.admNo}}" value="A"
                                                    [ngModel]="e.attendance" [disabled]="isAttendanceReadonly(e)"> A
                                            </label>
                                            <label class="att-radio-label att-radio-s"
                                                [class.att-radio-active]="e.attendance === 'S'"
                                                (click)="!isAttendanceReadonly(e) && onAttendanceChange(e, 'S')">
                                                <input type="radio" name="att{{e.admNo}}" value="S"
                                                    [ngModel]="e.attendance" [disabled]="isAttendanceReadonly(e)"> S
                                            </label>
                                            <label class="att-radio-label att-radio-o"
                                                [class.att-radio-active]="e.attendance === 'O'"
                                                (click)="!isAttendanceReadonly(e) && onAttendanceChange(e, 'O')">
                                                <input type="radio" name="att{{e.admNo}}" value="O"
                                                    [ngModel]="e.attendance" [disabled]="isAttendanceReadonly(e)"> O
                                            </label>
                                        </div>
                                    </td>
                                </ng-container>

                                <!-- Remarks -->
                                <ng-container matColumnDef="remarks">
                                    <th mat-header-cell *matHeaderCellDef class="att-th">Remarks</th>
                                    <td mat-cell *matCellDef="let e" class="att-td att-td-remarks">
                                        <span class="att-status-badge" [class.badge-present]="e.attendance === 'P'"
                                            [class.badge-absent]="e.attendance === 'A'"
                                            [class.badge-holiday]="e.attendance === 'H'"
                                            [class.badge-left]="e.attendance === 'L'"
                                            [class.badge-outing]="e.attendance === 'O'"
                                            [class.badge-sick]="e.attendance === 'S'"
                                            [class.badge-saved]="showAttendanceSavedTick(e)">
                                            <i class="fa fa-check att-status-tick" *ngIf="showAttendanceSavedTick(e)"
                                                aria-hidden="true"></i>
                                            {{ e.attendance === 'P' ? 'Present' : e.attendance === 'H' ? 'Holiday' :
                                            e.attendance === 'L' ?
                                            'Left' : e.attendance === 'O' ? 'Outing' : e.attendance === 'A' ? 'Absent' :
                                            e.attendance ===
                                            'S' ? 'Sick' : '—' }}
                                        </span>
                                        <input *ngIf="isRemarkInputVisible(e)" type="text"
                                            class="form-control form-control-sm att-remark-input"
                                            [(ngModel)]="e.remarks"
                                            placeholder="Enter remarks">
                                    </td>
                                </ng-container>

                                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                                <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="att-row"></tr>
                            </table>
                        </div>
                    </div>

                    <div class="att-table-footer">
                        <div class="att-table-footer-inner">
                            <div class="att-table-footer-stats">
                                <span class="stat-p">P: {{ presentCount }}</span>
                                <span class="stat-a">A: {{ absentCount }}</span>
                                <span class="stat-s">S: {{ sickCount }}</span>
                                <span class="stat-o">O: {{ outingCount }}</span>
                            </div>
                            <button type="button" class="att-save-btn" (click)="saveAttendanceRecords()"
                                [disabled]="!canSaveAttendance">
                                Save Attendance
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <!-- end .att-page-wrap -->
        </div>
    </div>
</div>

<div class="att-confirm-overlay" *ngIf="showSaveConfirm" (click)="closeSaveConfirm()">
    <div class="att-confirm-card" (click)="$event.stopPropagation()" role="dialog" aria-modal="true"
        aria-labelledby="attConfirmTitle">
        <div class="att-confirm-head">
            <div class="att-confirm-icon" aria-hidden="true">
                <i class="fa fa-check-circle"></i>
            </div>
            <div class="att-confirm-head-text">
                <h3 id="attConfirmTitle" class="att-confirm-title">Save attendance?</h3>
                <p class="att-confirm-sub">Please review the counts before saving.</p>
            </div>
            <button type="button" class="att-confirm-close" (click)="closeSaveConfirm()" aria-label="Close">
                <i class="fa fa-times"></i>
            </button>
        </div>

        <div class="att-confirm-body">
            <div class="att-confirm-grid">
                <div class="att-confirm-row" *ngFor="let row of confirmRows">
                    <span class="att-confirm-label">{{ row.label }}</span>
                    <span class="att-confirm-value" [title]="row.value">{{ row.value }}</span>
                </div>
            </div>
        </div>

        <div class="att-confirm-actions">
            <button type="button" class="att-confirm-btn att-confirm-btn-outline" (click)="closeSaveConfirm()">Cancel</button>
            <button type="button" class="att-confirm-btn att-confirm-btn-primary" (click)="confirmSaveAttendance()">
                <i class="fa fa-check" aria-hidden="true"></i>
                Yes, Save Attendance
            </button>
        </div>
    </div>
</div>

<!-- ================================ loader ======================-->
<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>